var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightGrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FFE9D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 14.8a.8.8 0 01.8-.8.8.8 0 000-1.6 2.4 2.4 0 00-2.4 2.4.8.8 0 001.6 0z",
    fill: "#730424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 20.4a.8.8 0 01-.8.8v2.4a2.4 2.4 0 11-4.8 0v-2.4a.8.8 0 01-.8-.8v-.204a5.6 5.6 0 116.4 0v.204zM14 15.6c0 1.48.803 2.772 2 3.465a.8.8 0 01.384.535h3.232a.8.8 0 01.383-.535 4 4 0 10-6-3.465zm3.2 6.4h1.6v-.8h-1.6v.8zm.8 2.4a.8.8 0 00.8-.8h-1.6a.8.8 0 00.8.8z",
    fill: "#730424"
  })));
}
export default __webpack_public_path__ + "fonts/insight-grow-b7738d4493f93540fdcc64afc2a6f9a4.svg";
export { SvgInsightGrow as ReactComponent };